/**
 * Простая типизированная шина событий (subscribe / off / emit).
 */

type Listener<T = unknown> = (payload: T) => void;

const listeners = new Map<string, Set<Listener<unknown>>>();

export function on<T = unknown>(event: string, fn: Listener<T>): void {
  const set = listeners.get(event) ?? new Set();
  set.add(fn as Listener<unknown>);
  listeners.set(event, set);
}

export function off<T = unknown>(event: string, fn: Listener<T>): void {
  const set = listeners.get(event);
  if (set) set.delete(fn as Listener<unknown>);
}

export function emit<T = unknown>(event: string, payload?: T): void {
  listeners.get(event)?.forEach((fn) => fn(payload));
}
